import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import SliderType from './SliderType'
import { viewPhotoSvc, saveStaffPhotoSvc, removePhotoSvc } from './StaffSvc'
import '../css/StaffCtrl.css'

const StaffPhoto = props => {
  const [loader, setLoader] = useState('none')
  const [photo, setPhoto] = useState('')
  useEffect(() => {
    if (
      props.selectedUserId !== 0 &&
      props.flgSliderType == SliderType.SLIDER_PHOTO
    ) {
      var promise = new Promise((resolve, reject) => {
        if (props.selectedUserId !== 0) viewPhoto(props.selectedUserId)
      })
    }
  }, [props.flgSliderType, props.selectedUserId, props.roleId])

  function viewPhoto(userId) {
    setLoader('block')
    viewPhotoSvc(userId, cbViewPhotoResp)
  }

  function cbViewPhotoResp(url, response) {
    // console.log(url)
    if (!url) {
      if (response.SvcStatus === 'Failure') {
        toast.error(response.SvcMsg)
      }
    } else {
      setPhoto(url)
    }
    setLoader('none')
  }

  const saveStaffPhoto = e => {
    // console.log(e.target.files[0].name)
    // console.log('src:' + URL.createObjectURL(e.target.files[0]))
    // console.log("saveStaffPhoto() called")
    if (e.target.files && e.target.files[0]) {
      setPhoto(URL.createObjectURL(e.target.files[0]))
      setLoader()
      saveStaffPhotoSvc(
        props.selectedUserId,
        e.target.files[0],
        cbSaveStaffPhotoResp
      )
    }
  }
  function handlePhotoClick() {
    // console.log(document.getElementById('img_pic'))
    // document.getElementById("img_pic").dispatchEvent(new Event('click'));
    document.getElementById('img_pic').click()
  }

  const onError = () => {
    // var errorURL = `https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350`
    var errorURL = window.appURL + '/no-image.png'
    setPhoto(errorURL)
  }

  function cbSaveStaffPhotoResp(data) {
    if (data.SvcStatus === 'Success') {
      toast.success(data.SvcMsg)
      setLoader('none')
    } else {
      toast.error(data.SvcMsg)
      setLoader('none')
      viewPhoto(props.selectedUserId)
    }
  }
  const removePhoto = () => {
    // console.log("removeStaffPhoto called");
    setLoader("block");
    removePhotoSvc(props.selectedUserId, removeStaffPhotoResponse);
  }
  const removeStaffPhotoResponse = (data) => {
    // console.log("removeStaffPhotoResponse called, data", data);
    if (data.status === "Success") {
      toast.success(data.message);
      const fileInput = document.getElementById("img_pic");
      if (fileInput) {
        fileInput.value = null; // Reset the file input
      }
      setPhoto('');
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setLoader("none");
  }

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };


  return (
    <form
      className='form form-horizontal'
      style={{
        width: '100%',
        margin: '0 auto',
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 10,
        pointerEvents: loader === 'none' ? 'auto' : 'none',
        overflowY: 'hidden'
      }}
    >
      <div
        style={{
          position: 'fixed',
          zIndex: 10000,
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: '50%',
          top: '50%',
          display: loader
        }}
      >
        <img
          className='loderImg'
          src={require('common/images/loader.gif')}
          alt='Loader...'
        />
      </div>
      <div
        className='EnquiryHead col-sm-12 col-centered'
        style={{
          border: '1px solid #aaa',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          fontWeight: 'bold'
        }}
      >
        <h4>Staff Photo - {props.flgSliderType}</h4>
      </div>
      <div className='col-sm-12'>
        <label className='col-sm-2 control-label text-left'>Photo</label>
        <div
          style={{ padding: 0, display: 'flex', width: 100, height: 100, border: "1px solid #ccc" }}
          className='form-group col-sm-3'
        >
          <input
            docid='3'
            type='file'
            id='img_pic'
            name='img'
            onChange={saveStaffPhoto}
            className='hidden'
            accept='image/*'
          />
          <img
            style={{
              display: 'block',
              width: '100%',
              maxWidth: '100%',
              height: 'auto',
              border: 0,
              objectFit: 'fill'
            }}
            id='staff_pic'
            src={photo}
            alt='img'
            onClick={e => handlePhotoClick(e)}
            onError={e => onError()}
          />
          <span
            id="removePhoto"
            title="Remove Photo"
            className="glyphicon glyphicon-remove-circle"
            style={{ color: '#f72424', position: 'absolute', right: '2px', top: '2px', fontSize:20 }}
            onClick={() => removePhoto()}
          ></span>
        </div>
      
      </div>
    </form>
  )
}
export default StaffPhoto
